import React from 'react';
import { Field, Text, Textarea, RadioGroup, Select, SectionShell } from './FormControls';
import SignaturePad from './SignaturePad';

const YES_NO = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
];

const SignOffSection = ({
  data,
  update,
  documentType = 'certificate',
  certificateDisqualifiers = [],
  torqueWrenchOptions = [],
  pressureGaugeOptions = [],
  dateExaminedDisplay = '',
  nextExaminationDateDisplay = '',
}) => {
  // Signature only applies to an actual certificate. If the user has selected
  // Report/Inspection, or a disqualifying condition is present, no signature is
  // taken and the PDF prints "This is not a certificate".
  const signatureDisabled = documentType !== 'certificate' || certificateDisqualifiers.length > 0;
  const disabledNotice = documentType !== 'certificate'
    ? 'Reports and inspections are not signed.'
    : (certificateDisqualifiers.length > 0
      ? `Cannot certify: ${certificateDisqualifiers.join('; ')}. This will be recorded as a report or inspection.`
      : undefined);
  return (
  <SectionShell title="Sign Off" description="Examiner conclusions and sign-off">
    <Field label="Employer Name" required>
      <Text value={data.employerName} onChange={(v) => update('employerName', v)} required />
    </Field>
    <Field label="Inspector Name" required>
      <Text value={data.inspectorName} onChange={(v) => update('inspectorName', v)} required />
    </Field>
    <Field
      label="Date Examined"
      required
      hint={dateExaminedDisplay ? `Prints on the certificate as ${dateExaminedDisplay}` : undefined}
    >
      <Text type="date" value={data.dateExamined} onChange={(v) => update('dateExamined', v)} required />
    </Field>
    <Field label="Inspector Certificate Number" required>
      <Text value={data.inspectorCertificateNumber} onChange={(v) => update('inspectorCertificateNumber', v)} required />
    </Field>
    <SignaturePad
      label="Inspector Signature"
      required
      value={data.inspectorSignature}
      onChange={(v) => update('inspectorSignature', v)}
      disabled={signatureDisabled}
      disabledNotice={disabledNotice}
    />
    <Field label="Additional Examination Required" required>
      <RadioGroup
        name="additionalExamination"
        value={data.additionalExamination}
        onChange={(v) => update('additionalExamination', v)}
        options={YES_NO}
      />
    </Field>
    <Field label="Vessel Satisfactory" required>
      <RadioGroup
        name="vesselSatisfactory"
        value={data.vesselSatisfactory}
        onChange={(v) => update('vesselSatisfactory', v)}
        options={YES_NO}
      />
    </Field>
    <Field label="Repairs Required" required>
      <RadioGroup
        name="repairsRequired"
        value={data.repairsRequired}
        onChange={(v) => update('repairsRequired', v)}
        options={YES_NO}
      />
    </Field>
    <Field label="Changes to Safe Operating Limits" required>
      <RadioGroup
        name="changesSafeLimits"
        value={data.changesSafeLimits}
        onChange={(v) => update('changesSafeLimits', v)}
        options={YES_NO}
      />
    </Field>
    <Field label="WSE Suitable" required>
      <RadioGroup
        name="wseSuitable"
        value={data.wseSuitable}
        onChange={(v) => update('wseSuitable', v)}
        options={YES_NO}
      />
    </Field>
    <Field label="Next Examination Date" required hint="Automatically set to 31 December, 10 years after the examination date.">
      <Text value={nextExaminationDateDisplay} onChange={() => {}} readOnly />
    </Field>
    <Field label="Torque Wrench Used" required hint="Serial number prints in the comments section.">
      <Select
        value={data.torqueWrench}
        onChange={(v) => update('torqueWrench', v)}
        options={torqueWrenchOptions}
        placeholder="Select torque wrench…"
      />
    </Field>
    <Field label="Pressure Gauge Used" required hint="Serial number prints in the comments section.">
      <Select
        value={data.pressureGauge}
        onChange={(v) => update('pressureGauge', v)}
        options={pressureGaugeOptions}
        placeholder="Select pressure gauge…"
      />
    </Field>
    <div className="md:col-span-2">
      <Field label="Comments">
        <Textarea value={data.comments} onChange={(v) => update('comments', v)} rows={4} />
      </Field>
    </div>
  </SectionShell>
  );
};

export default SignOffSection;
